export const getElementOffset = (el) => {
	let top: number = 0;
	let left: number = 0;
	let element = el;

	do {
		top += element.offsetTop || 0;
		left += element.offsetLeft || 0;
		element = element.offsetParent;
	} while (element);

	return {
		top,
		left
	};
};
